export default {
  textoDocumentos: {
    OUTROS: `Os "Outros" deverão ser compostos por ART, DRL (Declaração de Reconhecimento de Limites)
    e outros arquivos que se fizerem necessários.`
  },

  visualizarDocumentosPDF: {
    active: true,
    extensaoImagens: ['jpg', 'jpeg', 'png', 'heic', 'heif'],
    extensaoVisualizar: ['jpg', 'jpeg', 'png', 'heic', 'heif', 'pdf']
  },

  usePDFViewerOld: {
    active: false,
    minByteLength: 1048576
  }
}



// WEBPACK FOOTER //
// ./src/utils/pa/regrasAnalise.js